// ScoreManager.js
var ScoreManager = pc.createScript('scoreManager');

ScoreManager.attributes.add('Star', { type: 'entity'});
ScoreManager.attributes.add('ScoreText', {type : 'entity'});
ScoreManager.attributes.add('FactorText', {type : 'entity'});
ScoreManager.attributes.add('FactorYellowMaterial', {type : 'entity'});

var earnExtraPointsScore = 0;
//let ScoreManager.instance.animationContinue = true;

ScoreManager.prototype.initialize = function() {

    this.log = new Log("SCORE_MANAGER");
    ScoreManager.instance = this;

    this.comboCounter=2;
    this.maxComboCounter=1;
    this.stickerCounter = 0;
    this.factor = 1;
    this.speed = 0.05;
    this.scoreVal = 0;
    this.scoreManagerIsPaused = false;
    this.animationStarting = false;
    this.animationContinue = true;
    this.cloneFactorYellow = this.FactorYellowMaterial.element;
    this.cloneFactorYellow.material = this.cloneFactorYellow.material.clone();
    this.progressStatus = false;
    this.progress = 0.12;
    this.FactorText.element.text = '1x';
    this.app.on('gameManager:updatestatus',this.status,this);
    this.app.on('Score:add', this.ScoreCounter,this);
    this.entity.on("destroy", this.OnDestroy,this);
};

ScoreManager.prototype.setScore = function (score) {
    
    this.scoreVal = score;
    this.ScoreText.element.text = this.scoreVal.toString();
};

//Obje Merge yapildiktan sonra score animasyonu baslar.
ScoreManager.prototype.ScoreCounter = function(){
    
    for(i = 0; i < this.factor; i++){
        this.StarSpawns(i);
    }
    this.UpdateFactor();
};

//Score icin kayan yildiz animasyonunu tetikler.
ScoreManager.prototype.StarSpawns = function(count){

    let item = this.Star.clone();
    let star = this.Star;
    let tempUserScore = PlayerManager.instance.userData.score;
    PlayerManager.instance.userData.score++;
 
    let animationSpeed = 200;

    if (count<10) {
        animationSpeed = 200;
    }
    else if (count<20) {
        animationSpeed = 100;
    }
    else if (count>=20) {
        animationSpeed = 50;
    }
    
    setTimeout(function () {

        star.parent.addChild(item);
        item.enabled = true;
        tempUserScore++;
        ScoreManager.instance.ScoreText.element.text = tempUserScore.toString();
    }, animationSpeed * count, this);
};

//Score ekler ve Animasyon hizlarini arttirir.
ScoreManager.prototype.UpdateFactor = function(){
    
    this.Star.script.starAnimation.SpeedUpdate();
    
    if (this.factor > 1) {
        this.comboCounter++;

        if ((this.factor+1) >= this.maxComboCounter) {
            this.maxComboCounter = this.factor+1;
        }
    }
    else {
        this.comboCounter = 1;
    }

    this.factor += 1;
    this.factorTextAnimation = this.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(1.742, 2.948, 1), 0.4, pc.QuadraticInOut).on('complete', function () { ScoreManager.instance.factorAnimationDefault(1); });

    if (this.animationStarting == true) {

        ScoreManager.instance.animationContinue = false;

        setTimeout(function () {

            ScoreManager.instance.factorTextAnimation.start();
            ScoreManager.instance.animationStarting = true;
            ScoreManager.instance.animationContinue = true;
        }, 500, this);

    }
    else {
        this.factorTextAnimation.start();
        this.animationStarting = true;
        this.animationContinue = true;
    }
    
    this.speed += 0.015;
    this.FactorText.element.text = this.factor.toString() + 'x';
    this.progress = 0.12;

    if (!this.scoreManagerIsPaused)
    {
        this.progressStatus = true;
    }
    SoundManager.instance.playSound('StarFillUp');
};

ScoreManager.prototype.extraPoints = function () {
    
    earnExtraPointsScore = 0;
    let score = PlayerManager.instance.userData.userScore;

    if (score >= 100000) {
        earnExtraPointsScore = 400;
        return 400;
    }
    else if (score >= 50000) {
        earnExtraPointsScore = 350;
        return 350;
    }
    else if (score >= 10000) {
        earnExtraPointsScore = 300;
        return 300;
    }
    else if (score >= 5000) {
        earnExtraPointsScore = 250;
        return 250;
    }
    else if (score >= 1000) {
        earnExtraPointsScore = 200;
        return 200;
    }
    else if (score >= 500) {
        earnExtraPointsScore = 150;
        return 150;
    }
    else if (score >= 100) {
        earnExtraPointsScore = 100;
        return 100;
    }
    else if (score >= 0) {
        earnExtraPointsScore = 50;
        return 50;
    }
};
ScoreManager.prototype.status = function(stat) {
  
    if(stat === 2) ScoreManager.instance.ScoreText.element.text = PlayerManager.instance.userData.score.toString();
};

// Set progress - value is between 0 and 1.(Kapak altindaki progressbar oynatir.)
ScoreManager.prototype.setProgress = function (value) {

    this.progress = pc.math.clamp(value, 0.0, 1);
    this.cloneFactorYellow.material.alphaTest = this.progress;
};

//Kapak altindaki animasyonunu calistirir ve verilen surede basaramaz ise 1x'e geri doner.
ScoreManager.prototype.update = function(dt) {
    
    if(this.progressStatus){
        
        this.setProgress(this.progress + (dt * ScoreManager.instance.speed));
        
        if (this.progress >= 0.9) {
            this.Star.script.starAnimation.SpeedReset();
            this.progressStatus = false;
            ScoreManager.instance.factor = 1;
            ScoreManager.instance.speed = 0.05;
            ScoreManager.instance.FactorText.element.text = '1x';
        }   
    }
};

ScoreManager.prototype.resetFactory = function() {
    
    this.progressStatus = false;
    this.cloneFactorYellow.material.alphaTest = 1;
    this.Star.script.starAnimation.SpeedReset();
    
    this.factor = 1;
    this.speed = 0.05;
    this.FactorText.element.text = '1x';
};

ScoreManager.prototype.OnDestroy = function(){
    
    //console.log("Score Manager Destroy Oldu");
    this.factor = 1;
    this.speed = 0.05;
    
    
    this.app.off('Score:add', this.ScoreCounter,this);
    this.app.off('gameManager:updatestatus',this.status,this);
    this.entity.off("destroy", this.OnDestroy,this);
};

ScoreManager.prototype.isPaused = function() {
    
    if (this.progress != 0.12) {
        this.progressStatus=false;
    }
    this.scoreManagerIsPaused = true;
};

ScoreManager.prototype.isContinue = function() {
    
    if (this.progress != 0.12) {
        this.progressStatus=true;
    }
     this.scoreManagerIsPaused = false;
};

ScoreManager.prototype.factorAnimationDefault = function(step) {

    if (step == 1) {
        ScoreManager.instance.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(0.871, 1.474, 1), 0.4, pc.QuadraticInOut).on('complete', function(){ ScoreManager.instance.factorAnimation3x(); }).start();
    }
    else if (step == 3) {
        ScoreManager.instance.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(0.871, 1.474, 1), 0.375, pc.QuadraticInOut).on('complete', function(){ ScoreManager.instance.factorAnimation2x(); }).start();
    }
    else if (step == 5) {
        ScoreManager.instance.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(0.871, 1.474, 1), 0.35, pc.QuadraticInOut).on('complete', function(){ ScoreManager.instance.factorAnimation1x(); }).start();
    }
    else if (step == 7) {
        ScoreManager.instance.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(0.871, 1.474, 1), 0.325, pc.QuadraticInOut).on('complete', function(){ ScoreManager.instance.animationStarting = false; }).start();
    }
};

ScoreManager.prototype.factorAnimation3x = function() {

    if (ScoreManager.instance.animationContinue == true) {
        ScoreManager.instance.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(1.52425, 2.5795, 1), 0.375, pc.QuadraticInOut).on('complete', function(){ ScoreManager.instance.factorAnimationDefault(3); }).start();
    }
};
ScoreManager.prototype.factorAnimation2x = function() {

    if (ScoreManager.instance.animationContinue == true) {
        ScoreManager.instance.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(1.3065, 2.211, 1), 0.35, pc.QuadraticInOut).on('complete', function(){ ScoreManager.instance.factorAnimationDefault(5); }).start();
    }
    
};
ScoreManager.prototype.factorAnimation1x = function() {

    if (ScoreManager.instance.animationContinue == true) {
        ScoreManager.instance.FactorText.tween(ScoreManager.instance.FactorText.getLocalScale()).to(new pc.Vec3(1.08875, 1.8425, 1), 0.325, pc.QuadraticInOut).on('complete', function(){ ScoreManager.instance.factorAnimationDefault(7); }).start();
    }
};


